// Copyright (c) 2026 CTO's Club LLC. All rights reserved.

export const NATIVE_APP_LOGIN_PATH = '/login/open-anchorbase';

export function hasNativeAppLoginContinuation(searchParams: URLSearchParams): boolean {
    return searchParams.get('native_handoff') === '1';
}

export function appendNativeAppLoginContinuation(
    searchParams: URLSearchParams,
    enabled: boolean
): void {
    if (enabled) {
        searchParams.set('native_handoff', '1');
    }
}

export function buildPasswordChangePath(nativeAppLoginContinuation: boolean): string {
    return nativeAppLoginContinuation
        ? '/profile/password?native_handoff=1'
        : '/profile/password';
}
